<template>
  <b-card>
    <navigation-link-form @onSubmit="handleSubmit" :navigation-links="navigationLinks" :is-editing="false" />
  </b-card>
</template>

<script>
import NavigationLinkForm from '@/components/navigation-management/NavigationLinkForm';
import NotificationMixin from '@/mixins/NotificationMixin';
import { all, store } from '@/http/navigation-management';

export default {
  mixins: [NotificationMixin],

  components: {
    NavigationLinkForm,
  },

  data() {
    return {
      navigationLinks: [],
    };
  },

  async created() {
    await this.fetchNavigationLinks();
  },

  methods: {
    async fetchNavigationLinks() {
      try {
        const { data } = await all();
        this.navigationLinks = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linków nawigacji. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async handleSubmit(formData) {
      try {
        await store(formData);
        this.showSuccessNotification('Dane zostały zapisane', 'Link nawigacji został dodany.');
        this.$router.push({ name: 'navigation-management-index' });
      } catch (error) {
        const message =
          error.response?.data?.message ??
          'Wystąpił problem z dodaniem linku nawigacji. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
